<style scoped>
.teaxtarea-content {
    width: 100%;
    border: 1px solid black;
    padding: 15px;
    border-radius: 15px;
    background: none;
    background-position-x: 0%;
    background-position-y: 0%;
    background-repeat: repeat;
    background-image: none;
    background-position: 4% 50%;
    background-repeat: no-repeat;
    border: 1px solid #526170;
    outline: none;
    color: white;
    text-align: left;
    font-size: 20px;
    font-family: 'AgoraSans';
}

.teaxtarea-content:hover,
.teaxtarea-content:focus {
    color: rgba(0, 210, 234, 1);
    border: 1px solid #00a6ec;
    -webkit-box-shadow: 0 0 15px 0 #00a6ec, inset 0px 0px 15px 0 #00a6ec;
    box-shadow: 0 0 15px 0 #00a6ec, inset 0px 0px 15px 0 #00a6ec;
    caret-color: rgb(0, 148, 223);
}

.send-mail-block a.aquazor-btn {
    margin: 20px;
}

.send-mail-btn-block {
    text-align: right;
    display: block;
    padding: 10px 15px;
}

.input-block {
    margin: 25px 0;
}

.send-mail-block p,
.mail-list-block p,
.mail-list-block h4 {
    text-align: left;
}

.send-mail-block p {
    margin: 10px 0 0 0;
}

.mail-block {
    padding: 15px 15px 0px 15px;
    border-top: 1px solid rgba(204, 204, 204, 0.5);
}

.mail-list-block .clean-list {
    text-align: center;
}

.mail-list-block {
    margin: 20px 0 0 0;
}

.send-mail-btn-block .send-process p {
    visibility: hidden;
}

.send-mail-btn-block .aquazor-btn {
    padding: 13px 60px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
}

.send-mail-btn-block p {
    display: inline-block;
    margin-bottom: 0;
}

.send-mail-btn-block .aquazor-btn .button-loader {
    top: 31px;
    width: 44px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: 30px 14px;
}
</style>

<template>
<div>
    <div class="input-block send-mail-block row">
        <div class="row">
            <div class="offset-md-3 col-md-6" v-if="general_msg">
              <msg-component :type_msg="general_msg_type" :text="general_msg"></msg-component>
            </div>
            <div class="col-12">
                <p>Тема сообщения: </p>
            </div>
            <div class="col-12">
                <input v-model="mail_theme" type="text" autocomplete="off">
            </div>
                <div class="col-12">
                    <p>Сообщение: </p>
                </div>
                <div class="col-12">
                    <textarea class="teaxtarea-content" rows="5" v-model="mail_text"></textarea>
                </div>
            </div>
        </div>
        <div class="col-12 row send-mail-btn-block">
            <a class="aquazor-btn" @click="sendMail" v-bind:class="{'send-process': send_mail_status}">
                <p>Отправить</p> 
                <div class="button-loader" v-if="send_mail_status"></div>
            </a>
        </div>
        <loader-component v-if="loader"></loader-component>
        <div class="mail-list-block row" v-if="!loader">
            <div v-if="mails" class="row col-12">
                <div v-for="mail in mails" :key="mail.id" class="mail-block col-12">
                    <div>
                        <p>{{getTime(mail.timestamp)}}</p>
                    </div>
                    <div>
                        <h4>{{mail.theme}}</h4>
                    </div>
                    <div>
                        <p>{{mail.content_text}}</p>
                    </div>
                </div>
            </div>
            <div v-else>
                <p class="clean-list">Нет отправленных сообщений</p>
            </div>
        </div>
    </div>
</template>

<script>
import config from '@/config.js'
import axios from 'axios'
import loader from './loader.vue'
import moment from 'moment'
import msg from './msg.vue'

moment.locale('ru');

export default {
    created() {
        get_mails(this)
    },
    components: {
        'loader-component': loader,
        'msg-component': msg
    },
    methods: {
        sendMail: function () {
            send_mail(this)
        },
        getTime: function (timestamp) {
            var date = new Date()
            date.setTime(timestamp * 1000)
            return moment(date).format('lll')
        }
    },
    data() {
        return {
            loader: true,
            mails: null,
            general_msg: null,
            general_msg_type: null,
            mail_theme: '',
            mail_text: '',
            send_mail_status: false
        }
    },
    props: ['id_user']
}

function get_mails(vue_obj) {
    if (!!localStorage.token) {
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('id_user', vue_obj.id_user)
        post_data.set('limit', 0)
        axios({
                method: 'POST',
                url: config.API_HOST + '/aquazor-users/list_user_mails',
                data: post_data
            })
            .then(function (response) {
                vue_obj.mails = response.data.mails
                vue_obj.loader = false
            })
            .catch(function (error) {

            })
    }
}

function send_mail(vue_obj) {
    if (!!localStorage.token) {
        vue_obj.send_mail_status = true
        vue_obj.general_msg = null
        vue_obj.general_msg_type = null
        var post_data = new FormData()
        post_data.set('token', localStorage.token)
        post_data.set('id_user', vue_obj.id_user)
        post_data.set('theme', vue_obj.mail_theme)
        post_data.set('content', vue_obj.mail_text)
        axios({
                method: 'POST',
                url: config.API_HOST + '/aquazor-users/send_mail',
                data: post_data
            })
            .then(function (response) {
                vue_obj.$emit('hideModal')
            })
            .catch(function (error) {
                console.log(error)
                if (!!error.response.data.exception) {
                    vue_obj.general_msg_type = 'alert'
                    vue_obj.general_msg = error.response.data.exception
                }
            })
            .finally(function(){
                vue_obj.send_mail_status = false
            })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/user-mails.vue